import { ViewTypes } from 'components/spreadsheet/constants/const'
import { ISpreadsheetData } from 'components/spreadsheet/types'
import { ICustomViewDraft } from 'types'

/** A Custom View's page from MortaAI that its owners haven't published yet, or null: the save icon publishes it. */
export const getUnpublishedDraft = (spreadsheetData: ISpreadsheetData): ICustomViewDraft | null =>
  spreadsheetData.viewDetails.type === ViewTypes.CUSTOM_VIEW
    ? (spreadsheetData.viewDetails.customViewDraft ?? null)
    : null

export const hasUnpublishedDraft = (spreadsheetData: ISpreadsheetData): boolean =>
  getUnpublishedDraft(spreadsheetData) !== null

/** What the save icon saves: the view's own changes, and a Custom View's unpublished draft. */
export const hasUnsavedChanges = (spreadsheetData: ISpreadsheetData): boolean =>
  spreadsheetData.userConfiguration.unsavedChanges || hasUnpublishedDraft(spreadsheetData)
